import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const BankCardActiveSvg = ({ size = 24 }: { size?: number }) => (
  <SvgWrapper size={size}>
    <path
      d="M22.9101 12.4175C23.8969 11.6739 24.094 10.2713 23.3505 9.28453L22.9582 8.76399L5.38822 22.0039L5.78047 22.5245C6.52403 23.5112 7.9267 23.7083 8.91344 22.9648L22.9101 12.4175Z"
      fill="url(#paint0_linear-card)"
    />
    <path
      d="M4.08429 20.2735L21.6543 7.03362L18.2195 2.47554C17.476 1.4888 16.0733 1.29167 15.0865 2.03523L1.08984 12.5825C0.103109 13.3261 -0.0940246 14.7287 0.649531 15.7155L4.08429 20.2735Z"
      fill="url(#paint1_linear-card)"
    />
    <defs>
      <linearGradient
        id="paint0_linear-card"
        x1="-21.9855"
        y1="27.9171"
        x2="7.215"
        y2="49.3415"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79D2D3" />
        <stop offset="1" stopColor="#2DBEBF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear-card"
        x1="-21.9855"
        y1="27.9171"
        x2="7.215"
        y2="49.3415"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79D2D3" />
        <stop offset="1" stopColor="#2DBEBF" />
      </linearGradient>
    </defs>
  </SvgWrapper>
)
